/*
 * Курс «Английский с нуля до B2» — доменные шаги (english-course).
 *
 *   en-placement — «с чего начать»: с нуля или сначала тест уровня (/english-level-test);
 *   en-words     — карточки слов (слово, IPA, голос, перевод на языке страницы, пример
 *                  из диалога), затем быстрая проверка «перевод → английское слово»;
 *   en-dialog    — диалог урока двумя голосами, медленно, строку можно переслушать,
 *                  текст можно спрятать и слушать вслепую;
 *   en-examples  — примеры правила с голосом и пометкой на языке страницы;
 *   en-listen    — диктант: голос → человек печатает → разбор по словам;
 *   en-speak     — произношение: образец → человек говорит → распознаватель браузера
 *                  (WebSpeechSession) сверяет слова; без распознавателя — повтор вслух
 *                  с самооценкой, а не стена;
 *   en-produce   — своё письменное высказывание и образец ответа для сравнения.
 *
 * Голос — TTSHelper (public/js/lang/tts-helper.js): лучший доступный английский голос,
 * мужской/женский по собеседнику. Английский текст помечен lang="en" dir="ltr", чтобы
 * на арабской странице фраза не переворачивалась.
 * Тексты интерфейса — `ui` в resources/lang/{locale}/tools/english-course.php.
 */
(function () {
    'use strict';
    var K = window.CourseKit;
    if (!K) return;

    var LANG = 'en-US';

    function tts() { return window.TTSHelper && window.TTSHelper.isSupported && window.TTSHelper.isSupported() ? window.TTSHelper : null; }

    /* Сказать фразу; промис закрывается и на конце, и на отказе (не висит). */
    function say(text, o) {
        o = o || {};
        var T = tts();
        if (!T) return Promise.resolve(false);
        return new Promise(function (res) {
            var done = false;
            function fin(ok) { if (!done) { done = true; res(ok); } }
            var voice = null;
            try { if (o.gender && T.pickVoice) voice = T.pickVoice(LANG, { gender: o.gender }); } catch (_) {}
            try {
                T.speak(text, {
                    lang: LANG, rate: o.rate || 1, voice: voice || undefined,
                    onend: function (e) { fin(!(e && e.undelivered)); },
                    onerror: function () { fin(false); },
                    onstall: function () { fin(false); }
                });
            } catch (_) { fin(false); }
            setTimeout(function () { fin(false); }, 4000 + String(text).length * 160);
        });
    }
    function hush() { try { var T = tts(); if (T) T.cancel(); } catch (_) {} }

    function enEl(api, tag, cls, text) {
        var e = api.el(tag, cls, text);
        e.setAttribute('lang', 'en');
        e.setAttribute('dir', 'ltr');
        return e;
    }
    function btn(api, cls, label) {
        var b = api.el('button', cls, label);
        b.type = 'button';
        return b;
    }

    /* ── сравнение фраз по словам (диктант, произношение) ─────────────── */
    var NUM = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
        'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'];
    var CONTR = [
        [/\bcan't\b/g, 'can not'], [/\bcannot\b/g, 'can not'], [/\bwon't\b/g, 'will not'], [/\bshan't\b/g, 'shall not'],
        [/\blet's\b/g, 'let us'], [/n't\b/g, ' not'], [/'re\b/g, ' are'], [/'ve\b/g, ' have'], [/'ll\b/g, ' will'],
        [/'d\b/g, ' would'], [/\bi'm\b/g, 'i am'], [/\b(he|she|it|that|there|what|where|who|here)'s\b/g, '$1 is']
    ];
    function words(s) {
        s = String(s || '').toLowerCase().replace(/[‘’ʼ`]/g, "'");
        CONTR.forEach(function (c) { s = s.replace(c[0], c[1]); });
        s = s.replace(/[^a-z0-9'\s-]/g, ' ').replace(/-/g, ' ');
        return s.split(/\s+/).filter(Boolean).map(function (w) {
            w = w.replace(/^'+|'+$/g, '');
            if (/^\d+$/.test(w) && +w <= 20) return NUM[+w];
            if (w === 'ok' || w === 'okay') return 'ok';
            return w;
        }).filter(Boolean);
    }
    /* LCS по словам: какие слова образца найдены в ответе. */
    function align(target, got) {
        var n = target.length, m = got.length, i, j;
        var d = [];
        for (i = 0; i <= n; i++) { d.push(new Array(m + 1).fill(0)); }
        for (i = n - 1; i >= 0; i--) for (j = m - 1; j >= 0; j--) {
            d[i][j] = target[i] === got[j] ? d[i + 1][j + 1] + 1 : Math.max(d[i + 1][j], d[i][j + 1]);
        }
        var hit = new Array(n).fill(false);
        i = 0; j = 0;
        while (i < n && j < m) {
            if (target[i] === got[j]) { hit[i] = true; i++; j++; }
            else if (d[i + 1][j] >= d[i][j + 1]) i++; else j++;
        }
        var extra = Math.max(0, m - d[0][0]);
        return { hit: hit, matched: d[0][0], extra: extra };
    }
    function score(target, got) {
        var tw = words(target), gw = words(got);
        if (!tw.length) return { s: 1, tw: tw, hit: [] };
        var a = align(tw, gw);
        var s = Math.max(0, (a.matched - a.extra * 0.5) / tw.length);
        return { s: Math.min(1, s), tw: tw, hit: a.hit };
    }
    /* Образец с отметками: найденные слова зелёные, пропущенные красные. */
    function marked(api, sentence, hit) {
        var box = enEl(api, 'p', 'en-diff');
        var src = String(sentence).split(/\s+/);
        var k = 0;
        src.forEach(function (raw, idx) {
            var parts = words(raw);
            var ok = true;
            for (var p = 0; p < parts.length; p++) { if (!hit[k + p]) ok = false; }
            k += parts.length;
            var sp = api.el('span', parts.length ? (ok ? 'en-ok' : 'en-miss') : '', raw);
            box.appendChild(sp);
            if (idx < src.length - 1) box.appendChild(document.createTextNode(' '));
        });
        return box;
    }

    /* ── «с чего начать» ─────────────────────────────────────────────── */
    K.step('en-placement', {
        graded: false,
        mount: function (host, step, api) {
            var t = step.t || {};
            host.appendChild(api.el('h3', null, t.title || ''));
            host.appendChild(api.richEl('p', 'crs-prompt en-soft', t.body || ''));
            var row = api.el('div', 'en-place');
            var test = api.el('a', 'lg-btn lg-btn-ghost', api.tt('pl_test'));
            test.href = '/' + api.locale + '/english-level-test';
            row.appendChild(test);
            host.appendChild(row);
            api.primary(api.tt('pl_start'), function () { api.answer({ correct: null }); });
        }
    });

    /* ── слова ───────────────────────────────────────────────────────── */
    K.step('en-words', {
        reviewable: true,
        mount: function (host, step, api) {
            var t = step.t || {};
            var list = (step.words || []).map(function (w, i) { return { w: w.w, ipa: w.ipa, ex: w.ex, tr: (t.tr || [])[i] || '' }; });
            var box = api.el('div', 'en-words');
            host.appendChild(box);
            var i = 0;
            /* в «Повторении» и при возврате ошибки в конце урока карточки уже видены — сразу проверка */
            var quiz = api.mode === 'review' || !!step._again;

            function card() {
                box.innerHTML = '';
                var w = list[i];
                box.appendChild(api.el('p', 'crs-hint', api.tt('w_card', { n: i + 1, total: list.length })));
                var c = api.el('div', 'en-card');
                var head = api.el('div', 'en-card-head');
                head.appendChild(enEl(api, 'span', 'en-word', w.w));
                var play = btn(api, 'en-play', '🔊');
                play.setAttribute('aria-label', api.tt('w_listen') + ': ' + w.w);
                play.addEventListener('click', function () { say(w.w, { rate: 0.9 }); });
                head.appendChild(play);
                c.appendChild(head);
                if (w.ipa) c.appendChild(enEl(api, 'span', 'en-ipa', '/' + w.ipa + '/'));
                c.appendChild(api.el('p', 'en-tr', w.tr));
                if (w.ex) {
                    var ex = api.el('div', 'en-ex');
                    var exT = enEl(api, 'span', null, w.ex);
                    var exP = btn(api, 'en-play en-play-sm', '🔊');
                    exP.setAttribute('aria-label', api.tt('w_listen'));
                    exP.addEventListener('click', function () { say(w.ex); });
                    ex.appendChild(exP);
                    ex.appendChild(exT);
                    c.appendChild(ex);
                }
                box.appendChild(c);
                var nav = api.el('div', 'crs-acts');
                if (i > 0) {
                    var prev = btn(api, 'lg-btn lg-btn-ghost lg-btn-sm', '← ' + api.tt('w_prev'));
                    prev.addEventListener('click', function () { i--; card(); });
                    nav.appendChild(prev);
                }
                box.appendChild(nav);
                if (i < list.length - 1) {
                    api.primary(api.tt('w_next'), function () { i++; card(); say(list[i].w, { rate: 0.9 }); });
                } else {
                    api.primary(api.tt('w_quiz_start'), startQuiz);
                }
            }

            function startQuiz() {
                var order = api.shuffle(list.map(function (_, k) { return k; })).slice(0, Math.min(4, list.length));
                var qi = 0, right = 0, wrongs = [];
                api.primary(null, null);
                function ask() {
                    box.innerHTML = '';
                    var target = list[order[qi]];
                    box.appendChild(api.el('p', 'crs-hint', api.tt('w_quiz_n', { n: qi + 1, total: order.length })));
                    box.appendChild(api.el('p', 'crs-prompt', api.tt('w_quiz_q', { w: target.tr })));
                    var pool = list.filter(function (x) { return x !== target; });
                    pool = api.shuffle(pool).slice(0, 3).concat([target]);
                    pool = api.shuffle(pool);
                    var opts = api.el('div', 'crs-opts');
                    var bs = [];
                    pool.forEach(function (x, k) {
                        var b = btn(api, 'crs-opt');
                        b.appendChild(api.el('span', 'crs-opt-n', String(k + 1)));
                        b.appendChild(enEl(api, 'span', null, x.w));
                        b.addEventListener('click', function () {
                            bs.forEach(function (y) { y.disabled = true; });
                            var ok = x === target;
                            b.classList.add(ok ? 'is-right' : 'is-wrong');
                            if (!ok) {
                                wrongs.push(target.w + ' — ' + target.tr);
                                bs.forEach(function (y, z) { if (pool[z] === target) y.classList.add('is-right'); });
                            } else right++;
                            say(target.w, { rate: 0.9 });
                            setTimeout(function () {
                                if (!api.alive()) return;
                                qi++;
                                if (qi < order.length) ask(); else finish();
                            }, ok ? 700 : 1600);
                        });
                        bs.push(b);
                        opts.appendChild(b);
                    });
                    box.appendChild(opts);
                    api.onKey(function (k) {
                        var n = parseInt(k, 10);
                        if (n >= 1 && n <= bs.length && !bs[n - 1].disabled) { bs[n - 1].click(); return true; }
                        return false;
                    });
                }
                function finish() {
                    var s = order.length ? right / order.length : 1;
                    api.answer({ correct: s >= 0.75, score: s, reveal: wrongs.length ? wrongs.join('\n') : null,
                        explain: api.tt('w_quiz_res', { n: right, total: order.length }) });
                }
                ask();
            }
            if (quiz) startQuiz(); else card();
            api.onCleanup(hush);
        }
    });

    /* ── диалог ──────────────────────────────────────────────────────── */
    K.step('en-dialog', {
        graded: false,
        mount: function (host, step, api) {
            var lines = step.lines || [];
            var spk = step.speakers || {};
            host.appendChild(api.el('p', 'crs-hint', api.tt(tts() ? 'd_hint' : 'd_no_voice')));
            var bar = api.el('div', 'en-bar');
            var play = btn(api, 'lg-btn lg-btn-sm', '▶ ' + api.tt('d_play'));
            var slow = btn(api, 'crs-chip en-toggle', '🐢 ' + api.tt('d_slow'));
            slow.setAttribute('aria-pressed', 'false');
            var hide = btn(api, 'crs-chip en-toggle', api.tt('d_hide'));
            hide.setAttribute('aria-pressed', 'false');
            bar.appendChild(play); bar.appendChild(slow); bar.appendChild(hide);
            if (!tts()) { play.disabled = true; slow.disabled = true; hide.disabled = true; }
            host.appendChild(bar);
            var box = api.el('div', 'en-dialog');
            host.appendChild(box);
            var rows = lines.map(function (ln, k) {
                var p = spk[ln.s] || { n: ln.s, g: 'f' };
                var row = api.el('div', 'en-line ' + (p.g === 'm' ? 'en-line-b' : 'en-line-a'));
                var who = api.el('span', 'en-who', p.n);
                var b = btn(api, 'en-play en-play-sm', '🔊');
                b.setAttribute('aria-label', api.tt('w_listen') + ': ' + p.n);
                var col = api.el('div', 'en-line-c');
                var tx = enEl(api, 'span', 'en-line-t', ln.t);
                col.appendChild(who); col.appendChild(tx);
                row.appendChild(b); row.appendChild(col);
                b.addEventListener('click', function () { stop(); one(k); });
                box.appendChild(row);
                return row;
            });
            var playing = false, gen = 0;
            function rate() { return slow.getAttribute('aria-pressed') === 'true' ? 0.72 : 1; }
            function mark(k) { rows.forEach(function (r, z) { r.classList.toggle('is-now', z === k); }); }
            function one(k) {
                var ln = lines[k], p = spk[ln.s] || {};
                mark(k);
                return say(ln.t, { rate: rate(), gender: p.g === 'm' ? 'male' : 'female' }).then(function () { if (!playing) mark(-1); });
            }
            function stop() { playing = false; gen++; hush(); mark(-1); play.textContent = '▶ ' + api.tt('d_play'); }
            play.addEventListener('click', function () {
                if (playing) { stop(); return; }
                playing = true;
                var my = ++gen;
                play.textContent = '■ ' + api.tt('d_stop');
                var k = 0;
                (function next() {
                    if (!playing || my !== gen || !api.alive()) return;
                    if (k >= lines.length) { stop(); return; }
                    one(k++).then(function () { setTimeout(next, 250); });
                })();
            });
            slow.addEventListener('click', function () { slow.setAttribute('aria-pressed', slow.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); });
            hide.addEventListener('click', function () {
                var on = hide.getAttribute('aria-pressed') !== 'true';
                hide.setAttribute('aria-pressed', on ? 'true' : 'false');
                hide.textContent = api.tt(on ? 'd_show' : 'd_hide');
                box.classList.toggle('is-blind', on);
            });
            api.onCleanup(stop);
            api.primary(api.t('next'), function () { stop(); api.answer({ correct: null }); });
        }
    });

    /* ── примеры правила ─────────────────────────────────────────────── */
    K.step('en-examples', {
        graded: false,
        mount: function (host, step, api) {
            var t = step.t || {};
            host.appendChild(api.el('p', 'crs-hint', api.tt('ex_hint')));
            var ul = api.el('ul', 'en-examples');
            (step.items || []).forEach(function (it, k) {
                var li = api.el('li');
                var b = btn(api, 'en-play en-play-sm', '🔊');
                b.setAttribute('aria-label', api.tt('w_listen'));
                b.addEventListener('click', function () { say(it.en); });
                var en = enEl(api, 'span', 'en-ex-t');
                var html = api.rich(it.en);
                (it.hl || []).forEach(function (h) {
                    var safe = api.rich(h).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    html = html.replace(new RegExp('(^|[^\\w>])(' + safe + ')(?=$|[^\\w<])'), '$1<b>$2</b>');
                });
                en.innerHTML = html;
                var row = api.el('div', 'en-ex-row');
                row.appendChild(b); row.appendChild(en);
                li.appendChild(row);
                var note = (t.notes || [])[k];
                if (note) li.appendChild(api.richEl('span', 'en-note', note));
                ul.appendChild(li);
            });
            host.appendChild(ul);
            api.onCleanup(hush);
            api.primary(api.t('next'), function () { api.answer({ correct: null }); });
        }
    });

    /* ── диктант ─────────────────────────────────────────────────────── */
    K.step('en-listen', {
        reviewable: true,
        mount: function (host, step, api) {
            var sentence = step.say || '';
            if (!tts()) {
                host.appendChild(api.el('p', 'crs-hint', api.tt('l_no_voice')));
                api.primary(api.t('next'), function () { api.skip(api.tt('l_no_voice')); });
                return;
            }
            host.appendChild(api.el('p', 'crs-prompt', api.tt('l_hint')));
            var bar = api.el('div', 'en-bar');
            var p1 = btn(api, 'lg-btn lg-btn-sm', '▶ ' + api.tt('l_play'));
            var p2 = btn(api, 'lg-btn lg-btn-ghost lg-btn-sm', '🐢 ' + api.tt('l_slow'));
            p1.addEventListener('click', function () { say(sentence); });
            p2.addEventListener('click', function () { say(sentence, { rate: 0.65 }); });
            bar.appendChild(p1); bar.appendChild(p2);
            host.appendChild(bar);
            var inp = api.el('textarea', 'lg-input en-type');
            inp.rows = 2;
            inp.setAttribute('lang', 'en'); inp.setAttribute('dir', 'ltr');
            inp.setAttribute('autocapitalize', 'off'); inp.setAttribute('autocomplete', 'off'); inp.spellcheck = false;
            inp.placeholder = api.tt('l_placeholder');
            inp.setAttribute('aria-label', api.tt('l_hint'));
            host.appendChild(inp);
            var out = api.el('div', 'en-result');
            host.appendChild(out);
            var done = false;
            function check() {
                if (done || !inp.value.trim()) return;
                done = true;
                inp.disabled = true;
                var r = score(sentence, inp.value);
                out.appendChild(marked(api, sentence, r.hit));
                var n = r.hit.filter(Boolean).length;
                api.answer({ correct: r.s >= 0.85, score: r.s, reveal: r.s >= 0.85 ? null : sentence,
                    explain: api.tt('l_score', { n: n, total: r.tw.length }) });
            }
            inp.addEventListener('input', function () { api.primaryEnabled(!!inp.value.trim()); });
            inp.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); check(); } });
            api.primary(api.t('check'), check, true);
            api.onCleanup(hush);
        }
    });

    /* ── произношение ────────────────────────────────────────────────── */
    function recognizer() { return window.SpeechRecognition || window.webkitSpeechRecognition || null; }

    K.step('en-speak', {
        reviewable: false,
        mount: function (host, step, api) {
            var sentence = step.say || '';
            var box = api.el('div', 'en-speak');
            host.appendChild(box);
            box.appendChild(api.el('p', 'crs-prompt', api.tt('s_hint')));
            box.appendChild(enEl(api, 'p', 'en-say', sentence));
            var bar = api.el('div', 'en-bar');
            var model = btn(api, 'lg-btn lg-btn-ghost lg-btn-sm', '🔊 ' + api.tt('s_model'));
            model.addEventListener('click', function () { say(sentence, { rate: 0.9 }); });
            if (!tts()) model.disabled = true;
            bar.appendChild(model);
            box.appendChild(bar);
            var status = api.el('p', 'crs-hint en-status');
            status.setAttribute('aria-live', 'polite');
            var res = api.el('div', 'en-result');
            var canRecognize = !!recognizer() && typeof window.WebSpeechSession === 'function';
            var best = 0, tries = 0, session = null, listening = false, selfOnly = false;

            function selfPath(reason) {
                selfOnly = true;
                if (session) { try { session.stop(); } catch (_) {} }
                listening = false;
                status.textContent = reason;
                rec.hidden = true;
                api.primary(api.t('next'), function () { api.answer({ correct: null, explain: reason }); });
            }

            var rec = btn(api, 'lg-btn en-mic', '🎤 ' + api.tt('s_rec'));
            bar.appendChild(rec);
            box.appendChild(status);
            box.appendChild(res);
            if (!canRecognize) { selfPath(api.tt('s_no_sr')); return; }

            function finishTry(transcript) {
                if (selfOnly) return;
                listening = false;
                rec.textContent = '🎤 ' + api.tt(tries ? 's_again' : 's_rec');
                if (!transcript) { status.textContent = api.tt('s_nothing'); return; }
                tries++;
                var r = score(sentence, transcript);
                best = Math.max(best, r.s);
                res.innerHTML = '';
                res.appendChild(api.el('p', 'crs-hint', api.tt('s_heard')));
                res.appendChild(enEl(api, 'p', 'en-heard', transcript));
                res.appendChild(marked(api, sentence, r.hit));
                var n = r.hit.filter(Boolean).length;
                status.textContent = api.tt('s_result', { n: n, total: r.tw.length });
                if (r.s >= 0.85 || tries >= 3) {
                    api.primary(api.t('next'), function () {
                        api.answer({ correct: best >= 0.7, score: best, explain: api.tt('s_result', { n: n, total: r.tw.length }) });
                    });
                } else {
                    api.primary(api.t('next'), function () { api.answer({ correct: best >= 0.7, score: best }); });
                }
            }
            rec.addEventListener('click', function () {
                if (listening) { try { session && session.stop(); } catch (_) {} return; }
                hush();
                var heard = '';
                listening = true;
                rec.textContent = '■ ' + api.tt('s_stop');
                status.textContent = api.tt('s_listening');
                try {
                    session = new window.WebSpeechSession({
                        slug: 'english-course', lang: LANG, continuous: false, interimResults: true, autoRestart: false,
                        onResult: function (r) {
                            var tx = '';
                            for (var i = 0; i < r.results.length; i++) tx += r.results[i][0].transcript + ' ';
                            heard = tx.trim();
                            if (heard) status.textContent = heard;
                        },
                        onEnd: function () { if (api.alive()) finishTry(heard); },
                        onFatal: function () { if (api.alive()) selfPath(api.tt('s_no_sr')); }
                    });
                    session.start();
                } catch (_) { selfPath(api.tt('s_no_sr')); }
            });
            api.secondary(api.t('skip'), function () { api.skip(); });
            api.onCleanup(function () { hush(); try { session && session.stop(); } catch (_) {} });
        }
    });

    /* ── своё высказывание ───────────────────────────────────────────── */
    K.step('en-produce', {
        graded: false,
        mount: function (host, step, api) {
            var t = step.t || {};
            host.appendChild(api.richEl('p', 'crs-prompt', t.prompt || ''));
            var inp = api.el('textarea', 'lg-input en-type');
            inp.rows = 4;
            inp.setAttribute('lang', 'en'); inp.setAttribute('dir', 'ltr');
            inp.placeholder = api.tt('p_placeholder');
            inp.setAttribute('aria-label', t.prompt || api.tt('p_placeholder'));
            host.appendChild(inp);
            var cnt = api.el('p', 'crs-hint', api.tt('p_words', { n: 0 }));
            host.appendChild(cnt);
            var after = api.el('div', 'en-model');
            host.appendChild(after);
            inp.addEventListener('input', function () { cnt.textContent = api.tt('p_words', { n: words(inp.value).length }); });
            function reveal() {
                inp.readOnly = true;
                after.innerHTML = '';
                after.appendChild(api.el('span', 'crs-k', api.tt('p_model')));
                var m = enEl(api, 'p', 'en-say', step.model || '');
                after.appendChild(m);
                var mp = btn(api, 'en-play en-play-sm', '🔊');
                mp.setAttribute('aria-label', api.tt('w_listen'));
                mp.addEventListener('click', function () { say(step.model || ''); });
                after.appendChild(mp);
                after.appendChild(api.el('p', 'crs-prompt', api.t('self_q')));
                var row = api.el('div', 'crs-self');
                [['self_yes', 'self_yes_tx', 1], ['self_almost', 'self_almost_tx', 0.5], ['self_no', 'p_no_tx', 0]].forEach(function (x) {
                    var b = btn(api, 'lg-btn lg-btn-ghost', api.t(x[0]));
                    b.addEventListener('click', function () {
                        api.store.set('write:' + step._lesson, (inp.value || '').slice(0, 600));
                        api.answer({ correct: null, explain: x[1] === 'p_no_tx' ? api.tt(x[1]) : api.t(x[1]) });
                    });
                    row.appendChild(b);
                });
                after.appendChild(row);
                api.primary(null, null);
            }
            api.primary(api.tt('p_show'), reveal);
            var prev = api.store.get('write:' + step._lesson, '');
            if (prev) { inp.value = prev; cnt.textContent = api.tt('p_words', { n: words(prev).length }); }
        }
    });

    /* для стенда: сравнение фраз — чистая функция */
    window.__enCourseScore = score;
})();
